import React from 'react';
import PollIcon from '@mui/icons-material/Poll';
import { Accordion } from '../../../../../components/general/accordion';
import { PqrSurveyProps } from './props';
import { usePqrSurveyDetail } from './hook';
import { getQuestions } from '../../../pqr_web/survey/formData';
import { Box, Grid, Typography } from '@mui/material';
import { isValidKey } from '../../../../../../shared/utils/validKey';

export const PqrSurveyDetail = ({
    pqrSurvey: pqrSurveyDetail,
    halfName,
}: PqrSurveyProps) => {
    const { formik } = usePqrSurveyDetail(pqrSurveyDetail);

    return (
        <>
            <Accordion
                title="ENCUESTA"
                icon={<PollIcon sx={{ color: 'primary.main' }} />}
                defaultExpanded={false}
                mt={0}
            >
                <Grid container spacing={2} px={{ xs: 2, md: 6 }}>
                    {getQuestions(halfName).questions.map((question) => {
                        if (
                            formik.values[
                                question.id as keyof typeof formik.values
                            ].trim() === ''
                        )
                            return;

                        return (
                            <Grid item xs={12} key={question.id}>
                                <Box
                                    mb={2}
                                    p={2}
                                    borderRadius={2}
                                    sx={{ backgroundColor: '#EDE7F6' }}
                                >
                                    <Typography
                                        fontFamily="Lucida Sans"
                                        fontSize="1.2rem"
                                        fontWeight="700"
                                        textAlign="center"
                                        mb={1}
                                    >
                                        {question.text} <span>*</span>
                                        <br />
                                        <br />
                                        {isValidKey(question.id, formik.values)
                                            ? formik.values[question.id]
                                            : 'No disponible'}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Accordion>
        </>
    );
};
